import * as map from './map';
import * as address from './address';
import * as sites from './sites';

const query = {
  map,
  address,
  sites,
};
export default query;
